import React from 'react'
import { Col, Divider, Row } from 'antd'
import {
  TransactionsRequest,
  TransactionListItem,
} from '../../../services/api/transactions'
import { SubmitButton, Form } from 'formik-antd'
import { Formik } from 'formik'
import { SearchOutlined } from '@ant-design/icons'
import { CompanySelect, CreatedAtFilter, TransactionsTable } from './components'

type ExtendedTransactionListItem = TransactionListItem & {
  admin?: {
    id: string
    email: string
  }
}
type Props = {
  transactions?: ExtendedTransactionListItem[]

  meta?: {
    page: number | null
    perPage: number | null
    totalCount: number
  }
  isLoading: boolean
  companyId?: string
  onCompanyChange: (companyId?: string) => void
  initialValues: TransactionsRequest
  onSubmit: (form: TransactionsRequest) => void
  onPaginationChange: (page: number, perPage?: number) => void
}

export const View: React.FunctionComponent<Props> = ({
  transactions,
  companyId,
  onCompanyChange,
  meta,
  isLoading,
  initialValues,
  onPaginationChange,
  onSubmit,
}) => {
  return (
    <>
      <h2>Финансовые операции</h2>

      <Formik<TransactionsRequest>
        initialValues={initialValues}
        onSubmit={onSubmit}
      >
        <Form>
          <Row>
            <Col span={24}>
              <CompanySelect
                companyId={companyId}
                onCompanyChange={onCompanyChange}
              />
            </Col>
          </Row>

          <br />

          <Row gutter={[32, 0]}>
            <Col span={20}>
              <CreatedAtFilter />
            </Col>
            <Col span={4}>
              <SubmitButton
                size="large"
                loading={isLoading}
                style={{ width: '100%' }}
              >
                <SearchOutlined />
                Поиск
              </SubmitButton>
            </Col>
          </Row>
        </Form>
      </Formik>

      <Divider />

      <TransactionsTable
        transactions={transactions}
        meta={meta}
        isLoading={isLoading}
        onPaginationChange={onPaginationChange}
      />
    </>
  )
}
